import { useContext, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { AuthContext } from "./context/AuthContext";

import Sidebar from "./components/Sidebar";

import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import SetupHouseholdPage from "./pages/SetupHouseholdPage";

import MealsPage from "./pages/MealsPage";
import MealFormPage from "./pages/MealFormPage";
import MealPickerPage from "./pages/MealPickerPage";
import AddToPlannerPage from "./pages/AddToPlannerPage";
import WeekPlannerPage from "./pages/WeekPlannerPage";
import PantryPage from "./pages/PantryPage";
import GroceryPage from "./pages/GroceryPage";
import ProfilePage from "./pages/ProfilePage";
import DashboardPage from "./pages/DashboardPage";

export default function App(){

  const { user } = useContext(AuthContext);
  const location = useLocation();

  const [meals,setMeals] = useState([]);

  const hideSidebarRoutes = ["/setup"];

  const showSidebar =
    user && !hideSidebarRoutes.includes(location.pathname);

  if(!user){

    return(

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
      </Routes>

    )

  }

  return(

    <div className="appLayout">

      {showSidebar && <Sidebar />}

      <div className="mainContent">

        <Routes>

          <Route path="/setup" element={<SetupHouseholdPage />} />

          <Route
            path="/"
            element={<DashboardPage meals={meals} setMeals={setMeals} />}
          />

          <Route
            path="/meals"
            element={
              <MealsPage
                meals={meals}
                setMeals={setMeals}
              />
            }
          />

          <Route
            path="/meals/new"
            element={
              <MealFormPage
                meals={meals}
                setMeals={setMeals}
              />
            }
          />

          <Route
            path="/meals/edit/:id"
            element={
              <MealFormPage
                meals={meals}
                setMeals={setMeals}
              />
            }
          />

          <Route
            path="/meals/plan/:mealId"
            element={<AddToPlannerPage meals={meals} />}
          />

          <Route
            path="/planner"
            element={
              <WeekPlannerPage
                meals={meals}
                setMeals={setMeals}
              />
            }
          />

          <Route
            path="/planner/pick/:date/:mealType"
            element={<MealPickerPage />}
          />

          <Route
            path="/cook"
            element={<PantryPage meals={meals} setMeals={setMeals} />}
          />

          <Route
            path="/grocery"
            element={
              <GroceryPage meals={meals} setMeals={setMeals} />
            }
          />

          <Route
            path="/profile"
            element={<ProfilePage />}
          />

        </Routes>

      </div>

    </div>

  )

}